module.exports = __webpack_public_path__ + "img/key_features--safety.044811f3.png";